import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { ActionModalSchema, Context, Transitions } from "../../types"
import { saveCancelModalState } from "../manageModals"

export const deleteModalState: StateNodeConfig<
  Context,
  ActionModalSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ openDeleteModal: true }),
  exit: assign<Context>({ openDeleteModal: false }),
  ...saveCancelModalState(
    "#ManageUserModules.classes_page.loading",
    "deleteClass",
    {
      cancelTarget: "#ManageUserModules.classes_page.backToPrevious",
      loadingState: "remove",
      cancelActions: [
        assign<Context>(ctx => ({
          // If user clicks "Cancel" and details tray open, keep current selected record.
          // Otherwise, deselect it.
          ...(!ctx.openDetailsTray && { selectedClassRecord: null })
        }))
      ],
      onSuccess: (ctx, _evt) => ({
        snackbar: {
          message: `Successfully deleted ${ctx.snackbarMessageInfo}`,
          withUndo: true,
          undoAction: "UNDO_DELETE",
          error: false
        },
        lastDeletedClassRecordId: ctx.selectedClassRecord?.id,
        // If deleted from details tray, close details tray.
        ...(ctx.openDetailsTray && { openDetailsTray: false }),
        // Deselect current record.
        selectedClassRecord: null
      }),
      onError: (ctx, _evt) => ({
        snackbar: {
          message: `An error occurred. Unable to delete ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: true
        }
      })
    }
  )
}
